import { createBrowserClient } from "@supabase/ssr"

import { getSupabaseDataConfigFromEnv } from "../platformConfig.js"

type BrowserClientFactory = <Client = unknown>(
  url: string,
  anonKey: string
) => Client

type CreateDataClientOptions = {
  env?: NodeJS.ProcessEnv
  createBrowserClientImpl?: BrowserClientFactory
}

export function createDataClient<Client = unknown>({
  env,
  createBrowserClientImpl = createBrowserClient as unknown as BrowserClientFactory,
}: CreateDataClientOptions = {}): Client {
  const clientConfig = getSupabaseDataConfigFromEnv(
    env as Parameters<typeof getSupabaseDataConfigFromEnv>[0]
  )

  return createBrowserClientImpl<Client>(
    clientConfig.url,
    clientConfig.anonKey
  )
}
